/**
 * Determines if a DOM node contains only whitespace characters.
 */
const isNodeWhitespaceOnly = (node: Node): boolean => {
    switch (node.nodeType) {
        case Node.TEXT_NODE:
        case Node.ELEMENT_NODE:
            return !(node as Element).textContent?.trim();
        default:
            return true;
    }
};

/**
 * Removes trailing empty paragraphs (or other whitespace-only nodes) from the given HTML string.
 */
export const cleanHtmlTrailingEmptyParagraphs = (html: string): string => {
    const container = document.createElement('div');
    container.innerHTML = html;

    const children = Array.from(container.childNodes).reverse();

    // Loop through the children in reverse order and stop when we've stripped all empty paragraphs
    for (let i = 0; i < children.length - 1; i++) {
        const node = children[i];

        // If we've reached a node that isn't whitespace-only, stop processing
        if (!isNodeWhitespaceOnly(node)) break;

        container.removeChild(node);
    }

    return container.innerHTML;
};
